import { intl, ITranslations } from './config';

export const translate = (id: ITranslations, values?: Record<string, string | number>) =>
  intl.formatMessage({ id }, values);

export const translateHTML = (id: ITranslations, values?: Record<string, any>) =>
  intl.formatMessage(
    { id },
    {
      p: (...chunks) => <p className="u-margin-bottom">{chunks}</p>,
      ul: (...chunks) => <ul className="a-list">{chunks}</ul>,
      li: (...chunks) => <li>{chunks}</li>,
      b: (...chunks) => <b>{chunks}</b>,
      br: () => <br />,
      ...values,
    },
  );
